import { DisplayAd } from "src/components/DisplayAd/DisplayAd";
import { twStyledInlineDisplayAdStyles } from "../InlineAdStyles";
import type { InlineSerpAd } from "./InlineSerpAd";

export function InlineSerpGamAd({ setHasAd }: InlineSerpAd) {
  return (
    <DisplayAd
      onFilled={() => setHasAd(true)}
      slotConfigId="desktopInlineSerpAd"
      className={twStyledInlineDisplayAdStyles}
    />
  );
}
